// Global Data - Countries, Cities, Languages, and Training Categories
// Including Skill India Mission Programs and Government Vocational Training Schemes

// ==================== COUNTRIES & CITIES ====================
export const REGIONS = {
  'North America': {
    'United States': ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia', 'San Antonio', 'San Diego', 'Dallas', 'San Jose', 'Austin', 'Jacksonville', 'San Francisco', 'Seattle', 'Denver', 'Boston', 'Washington DC', 'Nashville', 'Detroit', 'Portland', 'Las Vegas', 'Memphis', 'Louisville', 'Baltimore', 'Milwaukee', 'Albuquerque', 'Tucson', 'Fresno', 'Sacramento', 'Atlanta', 'Miami', 'Minneapolis', 'New Orleans', 'Cleveland', 'Tampa', 'St. Louis', 'Pittsburgh', 'Cincinnati', 'Orlando', 'Charlotte', 'Raleigh', 'Salt Lake City', 'Kansas City', 'Indianapolis'],
    'Canada': ['Toronto', 'Montreal', 'Vancouver', 'Calgary', 'Edmonton', 'Ottawa', 'Winnipeg', 'Quebec City', 'Hamilton', 'Halifax', 'Victoria', 'Saskatoon', 'Regina'],
    'Mexico': ['Mexico City', 'Guadalajara', 'Monterrey', 'Puebla', 'Tijuana', 'León', 'Cancún', 'Mérida', 'Querétaro']
  },
  'South America': {
    'Brazil': ['São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador', 'Fortaleza', 'Belo Horizonte', 'Manaus', 'Curitiba', 'Recife', 'Porto Alegre'],
    'Argentina': ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata'],
    'Colombia': ['Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena'],
    'Chile': ['Santiago', 'Valparaíso', 'Concepción', 'Viña del Mar'],
    'Peru': ['Lima', 'Arequipa', 'Cusco', 'Trujillo'],
    'Venezuela': ['Caracas', 'Maracaibo', 'Valencia', 'Barquisimeto'],
    'Ecuador': ['Quito', 'Guayaquil', 'Cuenca'],
    'Uruguay': ['Montevideo', 'Punta del Este'],
    'Paraguay': ['Asunción'],
    'Bolivia': ['La Paz', 'Santa Cruz', 'Cochabamba']
  },
  'Europe': {
    'United Kingdom': ['London', 'Manchester', 'Birmingham', 'Leeds', 'Glasgow', 'Liverpool', 'Bristol', 'Edinburgh', 'Sheffield', 'Newcastle', 'Cardiff', 'Belfast', 'Nottingham', 'Southampton', 'Brighton', 'Leicester', 'Portsmouth', 'Oxford', 'Cambridge', 'York'],
    'Germany': ['Berlin', 'Munich', 'Frankfurt', 'Hamburg', 'Cologne', 'Düsseldorf', 'Stuttgart', 'Leipzig', 'Dresden', 'Hannover', 'Nuremberg', 'Bremen', 'Dortmund', 'Essen'],
    'France': ['Paris', 'Lyon', 'Marseille', 'Toulouse', 'Nice', 'Nantes', 'Strasbourg', 'Bordeaux', 'Lille', 'Montpellier', 'Rennes'],
    'Italy': ['Rome', 'Milan', 'Naples', 'Turin', 'Florence', 'Venice', 'Bologna', 'Genoa', 'Palermo', 'Verona'],
    'Spain': ['Madrid', 'Barcelona', 'Valencia', 'Seville', 'Bilbao', 'Málaga', 'Zaragoza', 'Murcia', 'Palma', 'Granada'],
    'Netherlands': ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht', 'Eindhoven', 'Groningen'],
    'Belgium': ['Brussels', 'Antwerp', 'Ghent', 'Bruges', 'Liège'],
    'Switzerland': ['Zurich', 'Geneva', 'Basel', 'Bern', 'Lausanne', 'Lucerne'],
    'Austria': ['Vienna', 'Salzburg', 'Innsbruck', 'Graz', 'Linz'],
    'Poland': ['Warsaw', 'Kraków', 'Gdańsk', 'Wrocław', 'Poznań', 'Łódź'],
    'Czech Republic': ['Prague', 'Brno', 'Ostrava'],
    'Sweden': ['Stockholm', 'Gothenburg', 'Malmö', 'Uppsala'],
    'Norway': ['Oslo', 'Bergen', 'Trondheim', 'Stavanger'],
    'Denmark': ['Copenhagen', 'Aarhus', 'Odense'],
    'Finland': ['Helsinki', 'Espoo', 'Tampere', 'Oulu'],
    'Ireland': ['Dublin', 'Cork', 'Galway', 'Limerick'],
    'Portugal': ['Lisbon', 'Porto', 'Braga', 'Faro'],
    'Greece': ['Athens', 'Thessaloniki', 'Patras', 'Heraklion'],
    'Hungary': ['Budapest', 'Debrecen', 'Szeged'],
    'Romania': ['Bucharest', 'Cluj-Napoca', 'Timișoara', 'Iași'],
    'Ukraine': ['Kyiv', 'Lviv', 'Odesa', 'Kharkiv', 'Dnipro'],
    'Russia': ['Moscow', 'Saint Petersburg', 'Novosibirsk', 'Yekaterinburg', 'Kazan']
  },
  'Asia Pacific': {
    'China': ['Shanghai', 'Beijing', 'Shenzhen', 'Guangzhou', 'Chengdu', 'Hangzhou', 'Nanjing', 'Wuhan', 'Xian', 'Suzhou', 'Tianjin', 'Chongqing', 'Qingdao', 'Dalian', 'Xiamen'],
    'Japan': ['Tokyo', 'Osaka', 'Nagoya', 'Yokohama', 'Fukuoka', 'Sapporo', 'Kobe', 'Kyoto', 'Sendai', 'Hiroshima'],
    'South Korea': ['Seoul', 'Busan', 'Incheon', 'Daegu', 'Daejeon', 'Gwangju', 'Ulsan'],
    'India': ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad', 'Jaipur', 'Lucknow', 'Chandigarh', 'Kochi', 'Indore', 'Nagpur', 'Coimbatore', 'Gurgaon', 'Noida', 'Surat', 'Vadodara', 'Visakhapatnam', 'Bhopal', 'Patna', 'Ranchi', 'Bhubaneswar', 'Guwahati', 'Thiruvananthapuram', 'Mysore', 'Mangalore', 'Nashik', 'Rajkot'],
    'Singapore': ['Singapore'],
    'Hong Kong': ['Hong Kong'],
    'Taiwan': ['Taipei', 'Kaohsiung', 'Taichung', 'Tainan'],
    'Thailand': ['Bangkok', 'Chiang Mai', 'Phuket', 'Pattaya'],
    'Vietnam': ['Ho Chi Minh City', 'Hanoi', 'Da Nang', 'Hai Phong'],
    'Malaysia': ['Kuala Lumpur', 'Penang', 'Johor Bahru', 'Malacca', 'Kota Kinabalu'],
    'Indonesia': ['Jakarta', 'Surabaya', 'Bandung', 'Medan', 'Bali'],
    'Philippines': ['Manila', 'Cebu', 'Davao', 'Quezon City'],
    'Australia': ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide', 'Gold Coast', 'Canberra', 'Newcastle', 'Hobart', 'Darwin'],
    'New Zealand': ['Auckland', 'Wellington', 'Christchurch', 'Hamilton', 'Queenstown'],
    'Pakistan': ['Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad'],
    'Bangladesh': ['Dhaka', 'Chittagong', 'Khulna', 'Sylhet'],
    'Sri Lanka': ['Colombo', 'Kandy', 'Galle'],
    'Nepal': ['Kathmandu', 'Pokhara']
  },
  'Middle East': {
    'UAE': ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Ras Al Khaimah'],
    'Saudi Arabia': ['Riyadh', 'Jeddah', 'Mecca', 'Medina', 'Dammam', 'Khobar'],
    'Qatar': ['Doha'],
    'Kuwait': ['Kuwait City'],
    'Bahrain': ['Manama'],
    'Oman': ['Muscat', 'Salalah'],
    'Israel': ['Tel Aviv', 'Jerusalem', 'Haifa', 'Eilat'],
    'Jordan': ['Amman', 'Aqaba'],
    'Lebanon': ['Beirut', 'Tripoli'],
    'Turkey': ['Istanbul', 'Ankara', 'Izmir', 'Antalya', 'Bursa'],
    'Iran': ['Tehran', 'Isfahan', 'Shiraz', 'Tabriz'],
    'Iraq': ['Baghdad', 'Erbil', 'Basra']
  },
  'Africa': {
    'South Africa': ['Johannesburg', 'Cape Town', 'Durban', 'Pretoria', 'Port Elizabeth'],
    'Egypt': ['Cairo', 'Alexandria', 'Giza', 'Sharm El Sheikh', 'Luxor'],
    'Nigeria': ['Lagos', 'Abuja', 'Port Harcourt', 'Kano', 'Ibadan'],
    'Kenya': ['Nairobi', 'Mombasa', 'Kisumu'],
    'Morocco': ['Casablanca', 'Marrakech', 'Rabat', 'Fez', 'Tangier'],
    'Ghana': ['Accra', 'Kumasi'],
    'Ethiopia': ['Addis Ababa'],
    'Tanzania': ['Dar es Salaam', 'Zanzibar', 'Arusha'],
    'Uganda': ['Kampala'],
    'Rwanda': ['Kigali'],
    'Senegal': ['Dakar'],
    'Ivory Coast': ['Abidjan'],
    'Tunisia': ['Tunis', 'Sfax'],
    'Algeria': ['Algiers', 'Oran'],
    'Mauritius': ['Port Louis'],
    'Botswana': ['Gaborone'],
    'Namibia': ['Windhoek'],
    'Zimbabwe': ['Harare', 'Bulawayo']
  },
  'Remote/Virtual': {
    'Global': ['Remote', 'Virtual', 'Online Only', 'Hybrid (Any Location)']
  }
};

// Flatten cities for dropdown
export const getAllCities = () => {
  const cities = [];
  Object.entries(REGIONS).forEach(([region, countries]) => {
    Object.entries(countries).forEach(([country, citiesList]) => {
      citiesList.forEach(city => {
        cities.push({ city, country, region });
      });
    });
  });
  return cities;
};

export const LOCATIONS = getAllCities().map(c => c.city);

// ==================== LANGUAGES ====================
export const LANGUAGES = [
  'English', 'Spanish', 'French', 'German', 'Portuguese', 'Italian', 'Dutch',
  'Russian', 'Polish', 'Ukrainian', 'Czech', 'Slovak', 'Hungarian', 'Romanian',
  'Greek', 'Turkish', 'Arabic', 'Hebrew', 'Persian (Farsi)', 'Urdu',
  'Hindi', 'Bengali', 'Punjabi', 'Tamil', 'Telugu', 'Kannada', 'Malayalam', 'Marathi', 'Gujarati', 'Odia', 'Assamese',
  'Mandarin Chinese', 'Cantonese', 'Japanese', 'Korean', 'Vietnamese', 'Thai', 'Indonesian', 'Malay', 'Filipino (Tagalog)',
  'Swedish', 'Norwegian', 'Danish', 'Finnish', 'Icelandic',
  'Swahili', 'Afrikaans', 'Zulu', 'Amharic', 'Hausa', 'Yoruba',
  'Serbian', 'Croatian', 'Bulgarian', 'Slovenian', 'Macedonian',
  'Catalan', 'Basque', 'Galician',
  'Welsh', 'Irish (Gaelic)', 'Scottish Gaelic',
  'Latvian', 'Lithuanian', 'Estonian',
  'Georgian', 'Armenian', 'Azerbaijani', 'Kazakh', 'Uzbek',
  'Nepali', 'Sinhala', 'Burmese', 'Khmer', 'Lao',
  'Mongolian', 'Tibetan'
];

// Country to Primary Language Mapping
export const COUNTRY_LANGUAGES = {
  'United States': 'English', 'Canada': 'English', 'Mexico': 'Spanish',
  'Brazil': 'Portuguese', 'Argentina': 'Spanish', 'Colombia': 'Spanish', 'Chile': 'Spanish', 'Peru': 'Spanish',
  'Venezuela': 'Spanish', 'Ecuador': 'Spanish', 'Uruguay': 'Spanish', 'Paraguay': 'Spanish', 'Bolivia': 'Spanish',
  'United Kingdom': 'English', 'Germany': 'German', 'France': 'French', 'Italy': 'Italian', 'Spain': 'Spanish',
  'Netherlands': 'Dutch', 'Belgium': 'Dutch', 'Switzerland': 'German', 'Austria': 'German', 'Poland': 'Polish',
  'Czech Republic': 'Czech', 'Sweden': 'Swedish', 'Norway': 'Norwegian', 'Denmark': 'Danish', 'Finland': 'Finnish',
  'Ireland': 'English', 'Portugal': 'Portuguese', 'Greece': 'Greek', 'Hungary': 'Hungarian', 'Romania': 'Romanian',
  'Ukraine': 'Ukrainian', 'Russia': 'Russian',
  'China': 'Mandarin Chinese', 'Japan': 'Japanese', 'South Korea': 'Korean', 'India': 'Hindi',
  'Singapore': 'English', 'Hong Kong': 'Cantonese', 'Taiwan': 'Mandarin Chinese',
  'Thailand': 'Thai', 'Vietnam': 'Vietnamese', 'Malaysia': 'Malay', 'Indonesia': 'Indonesian',
  'Philippines': 'Filipino (Tagalog)', 'Australia': 'English', 'New Zealand': 'English',
  'Pakistan': 'Urdu', 'Bangladesh': 'Bengali', 'Sri Lanka': 'Sinhala', 'Nepal': 'Nepali',
  'UAE': 'Arabic', 'Saudi Arabia': 'Arabic', 'Qatar': 'Arabic', 'Kuwait': 'Arabic',
  'Bahrain': 'Arabic', 'Oman': 'Arabic', 'Israel': 'Hebrew', 'Jordan': 'Arabic',
  'Lebanon': 'Arabic', 'Turkey': 'Turkish', 'Iran': 'Persian (Farsi)', 'Iraq': 'Arabic',
  'South Africa': 'English', 'Egypt': 'Arabic', 'Nigeria': 'English', 'Kenya': 'Swahili',
  'Morocco': 'Arabic', 'Ghana': 'English', 'Ethiopia': 'Amharic', 'Tanzania': 'Swahili',
  'Uganda': 'English', 'Rwanda': 'English', 'Senegal': 'French', 'Ivory Coast': 'French',
  'Tunisia': 'Arabic', 'Algeria': 'Arabic', 'Mauritius': 'English', 'Botswana': 'English',
  'Namibia': 'English', 'Zimbabwe': 'English', 'Global': 'English'
};

export const getLanguageForCountry = (country) => {
  return COUNTRY_LANGUAGES[country] || 'English';
};

// ==================== 3-TIER TRAINING CATEGORIES ====================
// Structure: Main Category -> Sub Category -> Training Types

export const TRAINING_CATEGORIES_3TIER = {
  // =============== SKILL INDIA MISSION & GOVERNMENT PROGRAMS ===============
  'Skill India Mission': {
    'PMKVY (Pradhan Mantri Kaushal Vikas Yojana)': {
      'Short Term Training (STT)': [
        'Fresh Skilling', 'Bridge Course', 'Skill Gap Training', 'Entry Level Training'
      ],
      'Recognition of Prior Learning (RPL)': [
        'RPL Camp Mode', 'RPL Employer Premises', 'RPL Best in Class Employer', 'RPL at PMKK'
      ],
      'Special Projects': [
        'Industry Partnership Training', 'Government Partnership Training', 'CSR Funded Projects'
      ]
    },
    'PMKK (Pradhan Mantri Kaushal Kendra)': {
      'Model Training Centers': [
        'Multi-Skill Training', 'Sector-Specific Training', 'District Level Training', 'State Level Training'
      ],
      'Aspirational Districts': [
        'Rural Skill Development', 'Tribal Area Training', 'Border Area Training'
      ]
    },
    'Jan Shikshan Sansthan (JSS)': {
      'Vocational Training': [
        'Literacy cum Skill Development', 'Non-Formal Education', 'Life Enrichment Programs'
      ],
      'Target Group Training': [
        'Women Empowerment Programs', 'SC/ST Skill Development', 'Minority Skill Training', 'Differently Abled Training'
      ]
    },
    'National Apprenticeship Promotion Scheme (NAPS)': {
      'Apprenticeship Types': [
        'Trade Apprentice', 'Graduate Apprentice', 'Technician Apprentice', 'Technician (Vocational) Apprentice'
      ],
      'Industry Sectors': [
        'Manufacturing Apprenticeship', 'Services Apprenticeship', 'IT/ITeS Apprenticeship'
      ]
    },
    'DDU-GKY (Deen Dayal Upadhyaya Grameen Kaushalya Yojana)': {
      'Rural Youth Training': [
        'Placement Linked Training', 'Captive Employment Training', 'Foreign Placement Training'
      ],
      'Special Categories': [
        'Women Rural Training', 'PwD Rural Training', 'SC/ST Rural Training'
      ]
    },
    'SANKALP (Skills Acquisition and Knowledge Awareness for Livelihood)': {
      'Institutional Strengthening': [
        'SSDM Capacity Building', 'Training Provider Development', 'Quality Assurance Training'
      ],
      'District Skilling': [
        'District Skill Committee Training', 'Local Skill Ecosystem Development'
      ]
    },
    'STRIVE (Skills Strengthening for Industrial Value Enhancement)': {
      'ITI Transformation': [
        'ITI Excellence Program', 'Dual System of Training', 'Industry-Institute Partnership'
      ],
      'Apprenticeship Enhancement': [
        'Apprenticeship Readiness Training', 'Employer Engagement Training'
      ]
    }
  },

  'National Skill Development Corporation (NSDC)': {
    'Sector Skill Councils (SSC)': {
      'Agriculture': [
        'Organic Farming', 'Precision Agriculture', 'Agricultural Equipment Operation', 'Horticulture', 'Floriculture'
      ],
      'Automotive': [
        'Automobile Service Technician', 'Electric Vehicle Technology', 'Auto Body Repair', 'Automotive Assembly'
      ],
      'Beauty & Wellness': [
        'Hair Styling', 'Skin Care', 'Makeup Artistry', 'Spa Therapy', 'Nail Art'
      ],
      'BFSI (Banking, Financial Services & Insurance)': [
        'Banking Operations', 'Insurance Sales', 'Mutual Fund Distribution', 'Microfinance', 'Digital Banking'
      ],
      'Capital Goods': [
        'CNC Machine Operation', 'Welding', 'Fitting', 'Industrial Automation', 'Tool & Die Making'
      ],
      'Construction': [
        'Mason', 'Bar Bending', 'Scaffolding', 'Plumbing', 'Electrician', 'Painting', 'Tiling'
      ],
      'Domestic Workers': [
        'Housekeeping', 'Cooking', 'Child Care', 'Elder Care', 'General House Work'
      ],
      'Electronics & Hardware': [
        'Mobile Phone Repair', 'Computer Hardware Repair', 'CCTV Installation', 'Solar Panel Installation', 'LED Light Assembly'
      ],
      'Food Processing': [
        'Food Production', 'Bakery', 'Pickle Making', 'Dairy Processing', 'Meat Processing'
      ],
      'Furniture & Fittings': [
        'Carpentry', 'Wood Carving', 'Modular Furniture', 'Upholstery'
      ],
      'Gems & Jewellery': [
        'Jewellery Making', 'Diamond Processing', 'Gem Cutting', 'Jewellery Design'
      ],
      'Green Jobs': [
        'Waste Management', 'Solar Energy', 'Wind Energy', 'E-Waste Recycling', 'Water Conservation'
      ],
      'Handicrafts & Carpet': [
        'Traditional Crafts', 'Carpet Weaving', 'Pottery', 'Embroidery', 'Block Printing'
      ],
      'Healthcare': [
        'General Duty Assistant', 'Home Health Aide', 'Phlebotomy', 'Medical Equipment Technician', 'Emergency Care'
      ],
      'Hydrocarbons': [
        'Oil Rig Operations', 'Refinery Operations', 'Pipeline Maintenance', 'LPG Technician'
      ],
      'Infrastructure Equipment': [
        'Tower Crane Operator', 'Excavator Operator', 'Road Roller Operator', 'Forklift Operator'
      ],
      'Iron & Steel': [
        'Steel Melting', 'Rolling Mill Operation', 'Quality Control', 'Furnace Operation'
      ],
      'IT-ITeS': [
        'Domestic Data Entry', 'CRM Domestic Voice', 'Software Testing', 'Web Development', 'BPO Operations'
      ],
      'Leather': [
        'Footwear Making', 'Leather Goods', 'Leather Processing', 'Shoe Design'
      ],
      'Life Sciences': [
        'Pharmaceutical Production', 'Quality Assurance', 'Clinical Research', 'Medical Coding'
      ],
      'Logistics': [
        'Warehouse Management', 'Inventory Control', 'Courier Services', 'Material Handling', 'Supply Chain'
      ],
      'Management & Entrepreneurship': [
        'Entrepreneurship Development', 'Business Management', 'Project Management', 'HR Management'
      ],
      'Media & Entertainment': [
        'Video Editing', 'Sound Engineering', 'Camera Operation', 'Animation', 'VFX'
      ],
      'Mining': [
        'Surface Mining', 'Underground Mining', 'Mine Safety', 'Drilling'
      ],
      'Paints & Coatings': [
        'Industrial Painting', 'Powder Coating', 'Spray Painting'
      ],
      'Plumbing': [
        'Plumber General', 'Plumber Advance', 'Pipe Fitter', 'Sanitary Hardware Fitter'
      ],
      'Power': [
        'Electrical Technician', 'Lineman', 'Substation Operator', 'Solar PV Installer'
      ],
      'Retail': [
        'Retail Sales Associate', 'Store Operations', 'Visual Merchandising', 'E-commerce Operations'
      ],
      'Rubber': [
        'Rubber Processing', 'Tyre Manufacturing', 'Rubber Product Testing'
      ],
      'Sports': [
        'Fitness Trainer', 'Sports Coach', 'Yoga Instructor', 'Sports Management'
      ],
      'Strategic Manufacturing': [
        'Defense Production', 'Aerospace Components', 'Precision Engineering'
      ],
      'Telecom': [
        'Telecom Tower Technician', 'Optical Fiber Technician', 'Mobile Tower Installation'
      ],
      'Textiles & Handloom': [
        'Weaving', 'Spinning', 'Dyeing', 'Garment Making', 'Fashion Design'
      ],
      'Tourism & Hospitality': [
        'Front Office', 'Food & Beverage', 'Housekeeping', 'Tour Guide', 'Travel Agent'
      ]
    },
    'Common Norms Training': {
      'Duration Based': [
        '200 Hours Training', '400 Hours Training', '600 Hours Training', '1000 Hours Training'
      ],
      'NSQF Levels': [
        'NSQF Level 1', 'NSQF Level 2', 'NSQF Level 3', 'NSQF Level 4', 'NSQF Level 5', 'NSQF Level 6', 'NSQF Level 7'
      ]
    }
  },

  'ITI & Craftsmen Training': {
    'Engineering Trades': {
      'Mechanical': [
        'Fitter', 'Turner', 'Machinist', 'Mechanic Motor Vehicle', 'Mechanic Diesel', 'Welder', 'Sheet Metal Worker'
      ],
      'Electrical': [
        'Electrician', 'Wireman', 'Electrical Maintenance', 'Instrument Mechanic'
      ],
      'Electronics': [
        'Electronics Mechanic', 'Mechanic Radio & TV', 'Information Technology', 'Computer Hardware'
      ],
      'Civil': [
        'Surveyor', 'Draughtsman Civil', 'Mason Building Constructor', 'Plumber'
      ]
    },
    'Non-Engineering Trades': {
      'Office Management': [
        'Stenographer English', 'Stenographer Hindi', 'COPA (Computer Operator)', 'Secretarial Practice'
      ],
      'Textile': [
        'Cutting & Sewing', 'Dress Making', 'Embroidery', 'Weaving'
      ],
      'Services': [
        'Hair & Skin Care', 'Catering & Hospitality', 'Health Sanitary Inspector'
      ]
    }
  },

  // =============== CORPORATE TRAINING CATEGORIES ===============
  'Corporate Leadership & Management': {
    'Executive Leadership': {
      'C-Suite Development': [
        'CEO Leadership Program', 'CFO Excellence', 'CHRO Development', 'CTO/CIO Development', 'CMO Leadership'
      ],
      'Strategic Leadership': [
        'Strategic Thinking', 'Strategic Planning', 'Business Strategy', 'Corporate Strategy', 'Competitive Strategy'
      ],
      'Leadership Styles': [
        'Transformational Leadership', 'Servant Leadership', 'Situational Leadership', 'Authentic Leadership', 'Adaptive Leadership'
      ]
    },
    'Management Development': {
      'First-Time Managers': [
        'New Manager Essentials', 'Transition to Management', 'Managing Former Peers', 'Building Credibility'
      ],
      'Middle Management': [
        'Operational Excellence', 'Cross-Functional Management', 'Resource Optimization', 'Team Scaling'
      ],
      'Senior Management': [
        'Executive Presence', 'Stakeholder Management', 'Board Reporting', 'M&A Integration Leadership'
      ]
    },
    'People Leadership': {
      'Team Management': [
        'Building High-Performance Teams', 'Team Motivation', 'Team Conflict Resolution', 'Virtual Team Leadership'
      ],
      'Talent Development': [
        'Coaching for Managers', 'Mentoring Skills', 'Performance Management', 'Succession Planning'
      ]
    }
  },

  'Communication & Professional Skills': {
    'Business Communication': {
      'Written Communication': [
        'Business Writing', 'Email Etiquette', 'Report Writing', 'Proposal Writing', 'Technical Writing'
      ],
      'Verbal Communication': [
        'Presentation Skills', 'Public Speaking', 'Storytelling for Business', 'Executive Communication', 'Media Training'
      ],
      'Interpersonal Communication': [
        'Active Listening', 'Feedback Skills', 'Difficult Conversations', 'Cross-Cultural Communication', 'Non-Verbal Communication'
      ]
    },
    'Negotiation & Influence': {
      'Negotiation Skills': [
        'Principled Negotiation', 'Sales Negotiation', 'Contract Negotiation', 'Salary Negotiation', 'Vendor Negotiation'
      ],
      'Influence & Persuasion': [
        'Influencing Without Authority', 'Stakeholder Influence', 'Building Consensus', 'Change Advocacy'
      ]
    },
    'Conflict Resolution': {
      'Workplace Conflict': [
        'Conflict Management Styles', 'Mediation Skills', 'De-escalation Techniques', 'Constructive Confrontation'
      ]
    }
  },

  'Sales & Revenue': {
    'Sales Methodology': {
      'Consultative Selling': [
        'SPIN Selling', 'Solution Selling', 'Challenger Sale', 'Value-Based Selling', 'MEDDIC'
      ],
      'Sales Process': [
        'Prospecting', 'Qualifying Leads', 'Discovery Calls', 'Proposal Presentation', 'Closing Techniques', 'Objection Handling'
      ]
    },
    'Account Management': {
      'Key Accounts': [
        'Strategic Account Planning', 'Account Growth Strategies', 'Executive Relationships', 'Account Retention'
      ],
      'Customer Success': [
        'Customer Onboarding', 'Adoption & Engagement', 'Renewal Management', 'Upselling & Cross-selling'
      ]
    },
    'Sales Leadership': {
      'Sales Management': [
        'Sales Team Leadership', 'Pipeline Management', 'Sales Forecasting', 'Territory Planning', 'Sales Coaching'
      ]
    }
  },

  'Technology & Digital': {
    'Software Development': {
      'Programming': [
        'Python', 'Java', 'JavaScript', 'C/C++', 'Go', 'Rust', 'TypeScript'
      ],
      'Web Development': [
        'Frontend Development (React, Angular, Vue)', 'Backend Development (Node.js, Django, Spring)', 'Full Stack Development', 'API Development'
      ],
      'Mobile Development': [
        'iOS Development (Swift)', 'Android Development (Kotlin)', 'React Native', 'Flutter', 'Cross-Platform Development'
      ]
    },
    'Cloud & DevOps': {
      'Cloud Platforms': [
        'AWS', 'Microsoft Azure', 'Google Cloud Platform', 'Multi-Cloud Strategy', 'Cloud Migration'
      ],
      'DevOps Practices': [
        'CI/CD Pipelines', 'Infrastructure as Code', 'Kubernetes', 'Docker', 'Site Reliability Engineering'
      ]
    },
    'Data & AI': {
      'Data Science': [
        'Data Analysis', 'Machine Learning', 'Deep Learning', 'Natural Language Processing', 'Computer Vision'
      ],
      'Data Engineering': [
        'Big Data Technologies', 'Data Pipelines', 'Data Warehousing', 'ETL Processes', 'Data Governance'
      ],
      'Business Intelligence': [
        'Data Visualization', 'Tableau', 'Power BI', 'Looker', 'Analytics Strategy'
      ],
      'AI & Automation': [
        'Generative AI', 'ChatGPT & LLMs', 'RPA (UiPath, Automation Anywhere)', 'AI Strategy', 'AI Ethics'
      ]
    },
    'Cybersecurity': {
      'Security Fundamentals': [
        'Information Security Basics', 'Network Security', 'Application Security', 'Cloud Security'
      ],
      'Advanced Security': [
        'Ethical Hacking', 'Penetration Testing', 'Security Operations (SOC)', 'Incident Response', 'Threat Intelligence'
      ]
    }
  },

  'Finance & Accounting': {
    'Financial Management': {
      'Corporate Finance': [
        'Financial Planning & Analysis', 'Budgeting & Forecasting', 'Working Capital Management', 'Capital Structure'
      ],
      'Investment & Valuation': [
        'Financial Modeling', 'Valuation Techniques', 'M&A Analysis', 'Private Equity', 'Venture Capital'
      ]
    },
    'Accounting': {
      'Financial Accounting': [
        'IFRS', 'GAAP', 'Financial Statement Preparation', 'Consolidation Accounting'
      ],
      'Management Accounting': [
        'Cost Accounting', 'Activity-Based Costing', 'Variance Analysis', 'Transfer Pricing'
      ],
      'Audit': [
        'Internal Audit', 'External Audit', 'Risk-Based Auditing', 'IT Audit', 'Forensic Accounting'
      ]
    },
    'Taxation': {
      'Tax Compliance': [
        'GST', 'Income Tax', 'International Taxation', 'Transfer Pricing Compliance'
      ]
    }
  },

  'Human Resources': {
    'Talent Management': {
      'Recruitment': [
        'Talent Acquisition Strategy', 'Interviewing Skills', 'Campus Recruitment', 'Executive Search', 'Employer Branding'
      ],
      'Learning & Development': [
        'Training Needs Analysis', 'Instructional Design', 'E-Learning Development', 'Learning Management Systems', 'ROI of Training'
      ],
      'Performance Management': [
        'Goal Setting (OKRs, KPIs)', 'Performance Reviews', 'Continuous Feedback', 'Performance Improvement Plans'
      ]
    },
    'HR Operations': {
      'Compensation & Benefits': [
        'Salary Benchmarking', 'Incentive Design', 'Benefits Administration', 'Total Rewards Strategy'
      ],
      'HR Analytics': [
        'People Analytics', 'Workforce Planning', 'Attrition Analysis', 'HR Dashboards'
      ],
      'HR Technology': [
        'HRMS Implementation', 'ATS Systems', 'HR Chatbots', 'Digital HR Transformation'
      ]
    },
    'Employee Experience': {
      'Engagement': [
        'Employee Engagement Strategies', 'Culture Building', 'Employee Well-being', 'Work-Life Balance Programs'
      ],
      'DEI (Diversity, Equity & Inclusion)': [
        'Unconscious Bias', 'Inclusive Leadership', 'Cultural Competency', 'Accessibility', 'LGBTQ+ Inclusion'
      ]
    }
  },

  'Marketing': {
    'Digital Marketing': {
      'Search & Content': [
        'SEO', 'SEM & Google Ads', 'Content Marketing', 'Content Strategy', 'Blogging & Copywriting'
      ],
      'Social Media': [
        'Social Media Strategy', 'LinkedIn Marketing', 'Facebook & Instagram Ads', 'Influencer Marketing', 'Community Management'
      ],
      'Performance Marketing': [
        'Marketing Analytics', 'Conversion Optimization', 'Attribution Modeling', 'Growth Hacking', 'A/B Testing'
      ]
    },
    'Brand & Product Marketing': {
      'Brand Management': [
        'Brand Strategy', 'Brand Positioning', 'Brand Identity', 'Rebranding', 'Brand Measurement'
      ],
      'Product Marketing': [
        'Go-to-Market Strategy', 'Product Launches', 'Competitive Analysis', 'Messaging & Positioning'
      ]
    },
    'Marketing Leadership': {
      'Marketing Strategy': [
        'Integrated Marketing', 'Marketing Planning', 'Budget Allocation', 'Agency Management', 'Marketing Operations'
      ]
    }
  },

  'Operations & Supply Chain': {
    'Operations Management': {
      'Process Excellence': [
        'Lean Management', 'Six Sigma (Green Belt, Black Belt)', 'Kaizen', 'Total Quality Management', 'Business Process Reengineering'
      ],
      'Production Management': [
        'Production Planning', 'Capacity Planning', 'Shop Floor Management', 'Manufacturing Excellence'
      ]
    },
    'Supply Chain': {
      'Procurement': [
        'Strategic Sourcing', 'Supplier Management', 'Contract Management', 'Category Management', 'Procurement Analytics'
      ],
      'Logistics': [
        'Warehouse Management', 'Transportation Management', 'Inventory Optimization', 'Last Mile Delivery', 'Cold Chain'
      ],
      'Planning': [
        'Demand Planning', 'Supply Planning', 'S&OP', 'Integrated Business Planning'
      ]
    }
  },

  'Project & Program Management': {
    'Project Management': {
      'Methodologies': [
        'PMP Certification Prep', 'PRINCE2', 'Waterfall', 'Critical Path Method', 'Earned Value Management'
      ],
      'Agile': [
        'Scrum Master', 'Product Owner', 'SAFe (Scaled Agile)', 'Kanban', 'Agile Coaching'
      ],
      'Tools': [
        'Microsoft Project', 'Jira & Confluence', 'Asana', 'Monday.com', 'Smartsheet'
      ]
    },
    'Program & Portfolio': {
      'Program Management': [
        'Program Governance', 'Benefits Realization', 'Stakeholder Management', 'Risk Management'
      ],
      'Portfolio Management': [
        'Portfolio Prioritization', 'Resource Allocation', 'Portfolio Governance', 'PMO Setup'
      ]
    }
  },

  'Compliance & Risk': {
    'Regulatory Compliance': {
      'Financial Regulations': [
        'Anti-Money Laundering (AML)', 'Know Your Customer (KYC)', 'FCPA', 'SOX Compliance'
      ],
      'Data & Privacy': [
        'GDPR', 'Data Protection', 'Privacy by Design', 'Data Subject Rights'
      ],
      'Industry-Specific': [
        'HIPAA (Healthcare)', 'PCI-DSS (Payments)', 'FDA Regulations (Pharma)', 'Environmental Compliance'
      ]
    },
    'Risk Management': {
      'Enterprise Risk': [
        'Risk Assessment', 'Risk Mitigation', 'Business Continuity', 'Crisis Management'
      ],
      'Operational Risk': [
        'Process Risk', 'Third-Party Risk', 'Technology Risk', 'Fraud Prevention'
      ]
    }
  },

  'Personal Development': {
    'Productivity': {
      'Time Management': [
        'Prioritization', 'Goal Setting', 'Calendar Management', 'Delegation', 'Focus & Concentration'
      ],
      'Effectiveness': [
        'Decision Making', 'Problem Solving', 'Critical Thinking', 'Creative Thinking', 'Systems Thinking'
      ]
    },
    'Wellness': {
      'Mental Health': [
        'Stress Management', 'Resilience Building', 'Mindfulness', 'Work-Life Balance', 'Burnout Prevention'
      ],
      'Physical Wellness': [
        'Ergonomics', 'Desk Exercises', 'Sleep Hygiene', 'Nutrition Basics'
      ]
    },
    'Career Development': {
      'Career Growth': [
        'Career Planning', 'Personal Branding', 'Networking Skills', 'LinkedIn Optimization', 'Interview Skills'
      ]
    }
  }
};

// Helper functions to navigate the 3-tier structure
export const getMainCategories = () => Object.keys(TRAINING_CATEGORIES_3TIER);

export const getSubCategories = (mainCategory) => {
  if (!mainCategory || !TRAINING_CATEGORIES_3TIER[mainCategory]) return [];
  return Object.keys(TRAINING_CATEGORIES_3TIER[mainCategory]);
};

export const getSubSubCategories = (mainCategory, subCategory) => {
  if (!mainCategory || !subCategory) return [];
  if (!TRAINING_CATEGORIES_3TIER[mainCategory]) return [];
  if (!TRAINING_CATEGORIES_3TIER[mainCategory][subCategory]) return [];
  return Object.keys(TRAINING_CATEGORIES_3TIER[mainCategory][subCategory]);
};

export const getTrainingTypes = (mainCategory, subCategory, subSubCategory) => {
  if (!mainCategory || !subCategory || !subSubCategory) return [];
  if (!TRAINING_CATEGORIES_3TIER[mainCategory]) return [];
  if (!TRAINING_CATEGORIES_3TIER[mainCategory][subCategory]) return [];
  if (!TRAINING_CATEGORIES_3TIER[mainCategory][subCategory][subSubCategory]) return [];
  return TRAINING_CATEGORIES_3TIER[mainCategory][subCategory][subSubCategory];
};

// Flatten all training types for search
export const getAllTrainingTypesFlat = () => {
  const types = [];
  Object.entries(TRAINING_CATEGORIES_3TIER).forEach(([main, subCats]) => {
    Object.entries(subCats).forEach(([sub, subSubCats]) => {
      Object.entries(subSubCats).forEach(([subSub, trainings]) => {
        trainings.forEach(training => {
          types.push({ main, sub, subSub, training });
        });
      });
    });
  });
  return types;
};

// ==================== SKILLS ====================
export const SKILLS = [
  // Leadership & Management
  'Leadership', 'Executive Coaching', 'Team Management', 'Strategic Planning', 'Change Management',
  'Performance Management', 'Talent Development', 'Succession Planning', 'Organizational Development',
  
  // Communication
  'Communication', 'Presentation Skills', 'Public Speaking', 'Business Writing', 'Storytelling',
  'Negotiation', 'Conflict Resolution', 'Facilitation', 'Training Delivery',
  
  // Business
  'Project Management', 'Agile', 'Scrum', 'Lean', 'Six Sigma', 'Process Improvement',
  'Business Strategy', 'Business Analysis', 'Business Acumen', 'Design Thinking',
  
  // Sales & Marketing
  'Sales', 'Business Development', 'Account Management', 'Marketing', 'Digital Marketing',
  'Brand Management', 'Customer Experience', 'Customer Service',
  
  // HR
  'HR', 'Recruitment', 'Employee Engagement', 'Learning & Development', 'Diversity & Inclusion',
  'Compensation & Benefits', 'Labor Relations', 'Organizational Behavior',
  
  // Finance
  'Finance', 'Financial Analysis', 'Budgeting', 'Accounting', 'Risk Management',
  'Investment', 'Treasury', 'Taxation', 'Audit',
  
  // Technology
  'Technology', 'Cloud Computing', 'Cybersecurity', 'AI/ML', 'Data Analytics',
  'DevOps', 'Software Development', 'IT Service Management', 'Digital Transformation',
  
  // Vocational
  'Vocational Training', 'Skill Development', 'ITI Trades', 'NSDC Certified',
  'Technical Training', 'Manufacturing', 'Construction', 'Healthcare Support',
  
  // Operations
  'Operations', 'Supply Chain', 'Logistics', 'Procurement', 'Quality Management',
  'Inventory Management', 'Vendor Management',
  
  // Compliance
  'Compliance', 'Risk & Compliance', 'Regulatory Affairs', 'Data Privacy', 'Ethics',
  'Health & Safety', 'Environmental Management', 'Corporate Governance',
  
  // Soft Skills
  'Soft Skills', 'Emotional Intelligence', 'Critical Thinking', 'Problem Solving',
  'Time Management', 'Stress Management', 'Mindfulness', 'Resilience'
];

// ==================== INDUSTRIES ====================
export const INDUSTRIES = [
  'Banking & Financial Services', 'Insurance', 'Investment Management', 'FinTech',
  'Healthcare & Hospitals', 'Pharmaceuticals', 'Medical Devices', 'Biotechnology', 'Life Sciences',
  'IT & Software', 'Technology & SaaS', 'Telecommunications', 'Media & Entertainment', 'Gaming',
  'E-commerce', 'Retail', 'FMCG/Consumer Goods',
  'Manufacturing', 'Automotive', 'Aerospace & Defense', 'Industrial Equipment',
  'Oil & Gas', 'Energy & Utilities', 'Renewable Energy', 'Mining & Metals', 'Chemicals',
  'Construction', 'Real Estate', 'Infrastructure',
  'Transportation & Logistics', 'Shipping & Maritime', 'Aviation',
  'Hospitality & Hotels', 'Travel & Tourism', 'Restaurants & Food Service',
  'Education & EdTech', 'Higher Education', 'Training & Development',
  'Government & Public Sector', 'Defense', 'Non-Profit & NGO',
  'Consulting', 'Professional Services', 'Legal Services', 'Accounting & Audit',
  'Advertising & Marketing', 'Public Relations',
  'Agriculture & Agribusiness', 'Food & Beverage',
  'Fashion & Apparel', 'Luxury Goods', 'Sports & Fitness', 'Wellness & Spa',
  'Skill Development', 'Vocational Training', 'ITI & Technical Education'
];

export default {
  REGIONS,
  LOCATIONS,
  LANGUAGES,
  COUNTRY_LANGUAGES,
  getLanguageForCountry,
  TRAINING_CATEGORIES_3TIER,
  getMainCategories,
  getSubCategories,
  getSubSubCategories,
  getTrainingTypes,
  getAllTrainingTypesFlat,
  SKILLS,
  INDUSTRIES,
  getAllCities
};
